import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import EndOfTenancy from './pages/EndOfTenancy';
import Commercial from './pages/Commercial';
import Residential from './pages/Residential';
import Locksmith from './pages/Locksmith';
import Handyman from './pages/Handyman';
import AdditionalServices from './pages/AdditionalServices';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import GetQuote from './pages/GetQuote';
import Gallery from './pages/Gallery';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/end-of-tenancy" element={<EndOfTenancy />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/locksmith" element={<Locksmith />} />
          <Route path="/handyman" element={<Handyman />} />
          <Route path="/additional-services" element={<AdditionalServices />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
